module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'btn-group': _vm.buttons, 'btn-group-justified': _vm.justified, 'btn-group-vertical': _vm.vertical
    },
    attrs: {
      "data-toggle": _vm.buttons && 'buttons'
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5f5e7910!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/vuestrap/buttonGroup.vue
// module id = 530
// module chunks = 2